import { gql } from '@apollo/client';

/**
 * The full career profile selection (spec 0018, increment B).
 *
 * Shared by `MyCareerProfile` (read) and `SaveCareerProfileForm` (write) so the
 * mutation returns a fresh, complete profile — the save response is used directly
 * as the new form baseline, avoiding a refetch that would clobber in-flight edits.
 *
 * Certificates carry `id` so the FE can round-trip it: the backend reconciles
 * certificates by id (update in place / create / delete), preserving admin files.
 */
export const CAREER_PROFILE_FIELDS = gql`
  fragment CareerProfileFields on CareerProfileType {
    id
    firstName
    lastName
    email
    phone
    photoUrl
    city
    country
    relocationReady
    workMode
    workPermit
    availableFrom
    seniority
    desiredPosition
    desiredSalary
    githubUrl
    linkedinUrl
    portfolioUrl
    customSkills
    isSearchable
    contactsVisible
    completeness
    skills {
      skillId
      name
      slug
      iconUrl
      category
      level
      years
      # ТЗ 0039. source = 'self' | 'course'. Навык «подтверждён школой»
      # ставит только сервер; в инпут это поле не отдаётся вовсе, поэтому
      # запросить его можно, а прислать — нет.
      # (Без обратных кавычек: они обрывают gql-литерал.)
      source
      isHidden
      grantedCourseName
      # ТЗ 0040. Занятие, на котором навык открылся: пусто, если он пришёл
      # за курс целиком. Экран печатает «получен на занятии №12».
      grantedLessonNumber
    }
    projects {
      id
      title
      description
      role
      repoUrl
      demoUrl
      technologyIds
      technologyNames
      # Объектный список нужен ради знака технологии: по одним идентификаторам
      # и именам его не построить, и редактор резюме показывал бы навык голым
      # текстом там, где витрина того же резюме рисует его со знаком.
      technologies {
        id
        name
        slug
        category
        iconUrl
      }
    }
    experience {
      id
      company
      position
      description
      startYear
      startMonth
      endYear
      endMonth
      isCurrent
    }
    education {
      id
      institution
      degree
      specialization
      startYear
      startMonth
      endYear
      endMonth
    }
    languages {
      id
      language
      level
    }
    certificates {
      id
      title
      issuer
      issuedAt
      url
      fileUrl
    }
    locales {
      language
      jobTitle
      about
    }
    cvSkillSuggestions {
      mentionedAs
      skill {
        id
        slug
        name
        category
        iconUrl
      }
    }
  }
`;
